import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20401 20401"
    {...props}
  >
    <defs>
      {/* <style>{".str0{stroke:#2b2a29;stroke-width:862}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <circle
        cx={10200}
        cy={10200}
        r={9769}
        className="fill"
        style={{
          fill: "#2b2a29",
          strokeWidth: 862,
        }}
      />
      <circle
        cx={10200}
        cy={10200}
        r={7542}
        className="stroke1"
        style={{
          fill: "#fefefe",
          strokeWidth: 862,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
